import { graphql } from "@cappelendamm/crystallize-types/core/gql";
export const GetCustomerByIdentifier = graphql(`
  query getCustomerByIdentifier($customerIdentifier: String!) {
    customer(identifier: $customerIdentifier) {
      __typename
      ... on Customer {
        type
        createdAt
        identifier
        firstName
        lastName
        companyName
        birthDate
        phone
        email
        addresses {
          type
          firstName
          lastName
          street
          postalCode
          city
          country
          email
          phone
          meta {
            key
            value
          }
        }
        externalReferences {
          key
          value
        }
        meta {
          key
          value
        }
        parents {
          identifier
          type
        }
      }
      ... on UnknownError {
        errorName
        message
      }
    }
  }
`);
